// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'            // 全局引入element-ui
import './assets/iconfont/iconfont.css'       // 字体图标
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.css'
import locale from 'element-ui/lib/locale' // elementUI的国际化
import store from './store'                  // vuex

import * as $utils from './assets/js/utils'          // 公共自定义钩子函数
import * as $api from './assets/js/api'              // api请求函数

import VueI18n from 'vue-i18n'
import languagePack from './assets/i18n'
// import menu from './assets/config/menu'          // 公共自定义钩子函数
import LeonInstruction from './instruction'               // 引入公共指令
// console.log(menu)
import Popup from './components/common/popup/index'
Vue.prototype.$popup = Popup.install
Vue.prototype.$utils = $utils
Vue.prototype.$api = $api

Vue.use(ElementUI)
// Vue.use(i18n)

Vue.use(LeonInstruction)                                  // 引入自定义指令
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem('coach:lang') === 'en' ? 'en' : 'zh',
  messages: languagePack
})

locale.i18n((key, value) => i18n.t(key, value)) // elementui多语言切换
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js